﻿/* Open header dropdown / mega menus on hover (desktop pointers only). Click still works. */
(function () {
  var mq = window.matchMedia('(hover: hover) and (min-width: 990px)');
  function bind() {
    if (!mq.matches) return;
    document.querySelectorAll('.header__inline-menu details').forEach(function (d) {
      if (d.dataset.kzHover) return;
      d.dataset.kzHover = '1';
      var t;
      var summary = d.querySelector('summary');
      d.addEventListener('mouseenter', function () {
        clearTimeout(t);
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (o) {
          if (o !== d) { o.removeAttribute('open'); var s = o.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'false'); }
        });
        d.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });
      d.addEventListener('mouseleave', function () {
        t = setTimeout(function () {
          d.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 180);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', bind);
})();
